import React from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Header from './DataComponent__TableHeader';
import Loading from '../Loading';

const DataComponentTableFinanceBlock = ({
    data: propData,
    loading: propLoading,
    headerNames: propHeaderNames,
    multiLevelHeaderNames: propMultiLevelHeaderNames,
    columnData: propColumnData,
    className: propClassName,
    t
}) => {
    const staticNames = t?.dataTable || {};

    const getKey = (data) => {
        if (React.isValidElement(data)) {
            if (Array.isArray(data.props.children)) {
                return getKey(data.props.children[0].props.children);
            } else {
                return getKey(data.props.children);
            }
        }

        return data;
    };

    return (
        <div className="loading-wrapper">
            {propLoading && propData.length
                ? <div className="loading-wrapper__item"><Loading /></div>
                : null
            }
            <div className="wrap__desktop">
                <div className="wrap__desktop-table">
                    <table className={`table table-data ${propClassName}`}>
                        <Header
                            headerNames={propHeaderNames}
                            multiLevelHeaderNames={propMultiLevelHeaderNames}
                            columnData={propColumnData.header}
                        />
                        <tbody>
                            {(propData || []).map((item, i) => {
                                let className = item.className;
                                delete item.className;
                                return (
                                    <tr key={'desktop-' + getKey(item.id || i)} className={className}>
                                        {Object.keys(item).map((key, j) => {
                                            const data = propColumnData.body[j] || {};
                                            let value;

                                            if (typeof item[key] === 'object') {
                                                value = item[key];
                                            } else if (typeof item[key] === 'string'){
                                                value = Parser(item[key]);
                                            }

                                            if(value === undefined) {
                                                return;
                                            }

                                            return <td className={key} key={j} {...data}>{value}</td>
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {!propData.length
                        ? propLoading
                            ? <Loading center={true} />
                            : <div className="text-center table-notfound-sign">{ staticNames.noData}</div>
                        : null
                    }
                </div>
            </div>
            <div className="wrap__mobile">
                <div className="payout__wrapper">
                    {(propData || []).map((item, i) => {
                        return (
                            <div className="payout" key={'mob-' + getKey(item.id || i)}>
                                {Object.keys(item).map((key, j) => {
                                    const data = propColumnData.body[j] || {};
                                    let value;

                                    if (typeof item[key] === 'object') {
                                        value = item[key];
                                    } else if (typeof item[key] === 'string'){
                                        value = Parser(item[key]);
                                    }

                                    if(value === undefined) {
                                        return;
                                    }

                                    return <div className={key} key={'mob-' + j} {...data}>{value}</div>
                                })}
                            </div>
                        )
                    })}
                    {!propData.length
                        ? propLoading
                            ? <Loading center={true} />
                            : <div className="text-center table-notfound-sign">{ staticNames.noData}</div>
                        : null
                    }
                </div>
            </div>
        </div>
    );
};

DataComponentTableFinanceBlock.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.object,
    className: PropTypes.string,
    t: PropTypes.object
};

DataComponentTableFinanceBlock.defaultProps = {
    data: [],
    loading: false,
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: { header: {}, body: {} },
    className: ''
};

export default withTranslation(DataComponentTableFinanceBlock);
